import React from "react";

import { CalendarDay } from "~/shared.types";
import { icons } from "~/ui";

type CalendarButtonProps = {
  calendarDays?: CalendarDay[];
  onDaySelect: (day: CalendarDay) => void;
  selectedDay?: CalendarDay;
  onMonthChange?: (monthYear: { month: string; year: number }) => void;
  onOpen?: () => void;
  isHidden?: boolean;
  disabled?: boolean;
};

export const CalendarButton = ({
  onOpen,
  isHidden,
  disabled,
}: CalendarButtonProps) => (
  <button
    onClick={onOpen}
    disabled={disabled}
    className={`focus:bg-light-lavender-gray/80 hover:bg-light-lavender-gray/50 cursor-pointer rounded-full p-2 transition-colors ${isHidden ? "invisible" : ""}`}
    aria-label="Open calendar"
  >
    <icons.outline.CalendarIcon className="text-blueGrey size-7" />
  </button>
);
